const $ = jQuery.noConflict();

const calculateHeight = () => {
    const $heroWrapper = $('.hero-homepage__video-bg');
    const windowHeight = $(window).outerHeight();
    const headerHeight = $('header').outerHeight();
    $heroWrapper.height(windowHeight - headerHeight)
}

function HomepageVideoHeight() {
    calculateHeight();
    const $iframeWrapper = $('.hero-homepage__background-file');
    const $iframeFile = $iframeWrapper.find('iframe');
    const $wrapperHeight = $iframeWrapper.height();
    const $wrapperWidth = $iframeWrapper.width();
    const $videoHeight = $iframeFile.attr('height') ?  $iframeFile.attr('height') : $iframeFile.height();
    const $videoWidth = $iframeFile.attr('width') ? $iframeFile.attr('width') : $iframeFile.width();

    const $videoAspectRatio = $videoHeight * 100 / $videoWidth;

    const $videoSupposeHeight =  $wrapperWidth * $videoAspectRatio / 100 < $wrapperHeight ? $wrapperHeight : Math.round($wrapperWidth * $videoAspectRatio / 100);
    const $videoSupposeWidth =  $videoSupposeHeight === $wrapperHeight ? Math.round($videoSupposeHeight * 100 / $videoAspectRatio) : $wrapperWidth;

    $iframeFile.width($videoSupposeWidth + 1);
    $iframeFile.height($videoSupposeHeight + 1);

}

export default HomepageVideoHeight;
